export default __webpack_public_path__ + "static/media/Mark-4-Blueprints-00.da56caee.jpg";